import primaryNav from "../PrimaryNav/primaryNav.js";
import mobileNav from "../MobileNav/mobileNav.js";
import searchMenu from "../SearchMenu/searchMenu.js";

export default () => {
  document.querySelectorAll(".js-primary-nav").forEach((el, i) => {
    primaryNav(el, i);
  });

  document.querySelectorAll(".js-mobile-nav").forEach((el, i) => {
    mobileNav(el, i);
  });

  document.querySelectorAll(".js-search-menu").forEach((el, i) => {
    searchMenu(el, i);
  });
};
